import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distanceFormat',
  standalone: true
})
export class DistanceFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || isNaN(value)) {
      return '-';
    }

    if (value < 1000) {
      return `${Math.round(value)} m`;
    } else {
      const km = value / 1000;
      return `${km.toFixed(km < 10 ? 2 : 1)} km`;
    }
  }
}
